<template>
  <div>
    <div v-if="errorStatus" class="alert alert-danger my-3" role="alert" v-html="errorStatus">
    </div>
    <div v-if="!isContainerInited" class="d-flex align-items-center justify-content-center" style="min-height:300px">
      <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="!hasSession" class="alert alert-primary my-3" role="alert">
      <i class="bi bi-lock"></i>You aren't signed into an account. Please <a href="#signinModal" data-bs-toggle="modal">sign in</a> to usage information.
    </div>
    <div v-else-if="isLoading" class="d-flex align-items-center justify-content-center" style="min-height:300px">
        <div class="spinner-border mx-2" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        Loading...
    </div>
    <div v-else-if="noData">
      <div v-if="errorStatus" class="alert alert-info my-3" role="alert">
        No usage data available.
      </div>
    </div>
    <template v-else>
    <h4>Query Count and Record Cost Summary</h4>
    <div class="text-muted mb-3" style="font-size: 0.95em;">
      All usage is calculated based on UTC time. In your local time, the day starts at: 
      {{ localDayStart }}
    </div>
       <div class="row" v-if="isFairUse || isFixedLimit">             
          <div class="kpi col-12 col-md-6 pt-3">
            <div class="card border-0 shadow  text-center p-3">
              <div class="h4 text-muted">Queries Today</div>
              <div class="h3">{{queriesText}}</div>
              <div v-if="maxDailyQueriesText" class="fs-s text-muted">{{queriesText}} of {{maxDailyQueriesText}}/day</div>
            </div>
          </div>
          <div class="kpi col-12 col-md-6 ps-3 pt-3">
            <div class="card border-0 shadow text-center p-3">
              <div class="h4 text-muted">Record Cost Today</div>
              <div class="h3">{{costText}}</div>
              <div v-if="maxDailyCostText" class="fs-s text-muted">{{costText}} of {{maxDailyCostText}}/day</div> 
            </div>
          </div>
          <div class="kpi col-12 col-md-6 pt-3">
            <div class="card border-0 shadow  text-center p-3">
              <div class="h4 text-muted">Queries This Period</div>
              <div class="h3">{{periodQueriesText}}</div>
              <div v-if="maxMonthlyQueriesText" class="fs-s text-muted">{{periodQueriesText}} of {{maxMonthlyQueriesText}}/month</div> 
            </div>
          </div>
          <div class="kpi col-12 col-md-6 ps-3 pt-3">
            <div class="card border-0 shadow text-center p-3">
              <div class="h4 text-muted">Record Cost This Period</div>
              <div class="h3">{{periodCostText}}</div>
              <div v-if="maxMonthlyCostText" class="fs-s text-muted">{{periodCostText}} of {{maxMonthlyCostText}}/month</div>
            </div>
          </div>
        </div>
        <template v-if="isMetered">
          <div class="row">
            <div class="kpi col-12 col-md-4  pt-3">
              <div class="card border-0 shadow  text-center p-3">
                <div class="h4 text-muted">Queries</div>
                <div class="h3">{{queriesText}}</div>
                <div class="fs-s text-muted">&nbsp;</div>
              </div>
            </div>
            <div class="kpi col-12 col-md-4 ps-3  pt-3">
              <div class="card border-0 shadow text-center p-3">
                <div class="h4 text-muted">Record Cost</div>
                <div class="h3">{{costText}}</div>
                 <div class="fs-s text-muted">{{freeDailyCostText}} free/day</div>
              </div>
            </div>
            <div class="kpi col-12 col-md-4 ps-3  pt-3">
              <div class="card border-0 shadow  text-center p-3">
                <div class="h4 text-muted">Available Free Credits</div>
                <div class="h3">{{availableCreditsText}}</div>
                 <div class="fs-s text-muted">&nbsp;</div>
              </div>
            </div>
          </div>
          <h4 class="mt-3">Usage charges</h4>
          <div class="row justify-content-center">
            <div class="kpi col-12 col-md-6">
              <div class="card border-0 shadow  text-center p-3">
                <div class="h4 text-muted">This invoice period</div>
                <div class="h3">{{invoiceBalanceText}}</div>
                <div class="fs-s text-muted">Invoice Date: {{invoiceDueDate}}</div>
               </div>
            </div>
          </div>
        </template>

<!--
    <div class="row">
     
      <div class="kpi col-12 col-md-6 ">
        <div class="card border-0 shadow  text-center p-3">
          <div class="h4 text-muted">Queries</div>
          <div class="h3">{{queriesText}}</div>
          <div class="fs-s text-muted">{{queriesText}} of {{maxQueriesText}}</div>
        </div>
      </div>
       <div class="kpi col-12 col-md-6 ps-3">
        <div class="card border-0 shadow text-center p-3">
          <div class="h4 text-muted">Records</div>
          <div class="h4">{{costText}}</div>
          <div class="fs-s text-muted">{{costText}} of {{maxCostText}}</div>
        </div>
      </div>

    </div>

   
    <h4>This month</h4>
 -->

    <h4 class="mt-5">Recent Daily history</h4>
    <table class="table table-striped fs-s">
      <thead>
        <tr>
          <th>Date</th>
          <th>Queries</th>
          <th>Cost</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item,index) in historicalUsageReverse">
          <tr>
            <td scope="col" class="text-nowrap px-2 py-1">{{item.period}} </td>
            <td scope="col" class="text-nowrap px-2 py-1">{{item.queryCount}} </td>
            <td scope="col" class="text-nowrap px-2 py-1">{{item.cost}} </td>
          </tr>
        </template>
      </tbody>
        
    </table>

    </template>
    <CommonModals />
  </div>
 
</template>

<script>
import CommonModals from '/src/components/CommonModals.vue'
import "/src/visualcrossing-core/vccommunicator_account";
import {VcPrettyNumberFormatter} from '/src/visualcrossing-core/vcprettynumberformatter';
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import {VcGlobal} from '/src/visualcrossing-core/vcglobal_conn';
export default {
  name: 'usagesummary',
  props: {
    
  },
  data() {
    return {
      isContainerInited:false,
      sessionId:null,
      sessionState:null,
      errorStatus:null,
      usageInfo:null,
      isLoading:false,
    }
  },
  methods:{
    refreshUsageInfo() {
      var me=this;
      if (!me.hasSession) return;
      me.isLoading=true;
      me.customerInfo=null;
       
      vcCommunicator.usagesummary()
        .then(function (result) {
          me.isLoading=false;
         
          me.usageInfo=result;
           me.errorStatus=null;
        }).catch((error) => {
          me.isLoading=false;
          
          me.errorStatus="There was a problem loading the usage information. <br/>"+error;
        });
    },
  },
  computed:{
    localDayStart() {
      // Get today's UTC midnight, then show as local time string (time only)
      const now = new Date();
      const utcMidnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
      return utcMidnight.toLocaleTimeString([], { hour: 'numeric', hour12: true }).toLowerCase();
    },
    subscriptionParams() {
      return this.sessionState.subscriptionParams;
    },
    maxDailyCost() {
      var me=this;
      if (me.isFairUse || !me.subscriptionParams || !me.subscriptionParams.maxDailyCost || me.subscriptionParams.maxDailyCost<=0 || me.subscriptionParams.maxDailyCost===2147483647) return -1;
      return me.subscriptionParams.maxDailyCost;
    },
    maxMonthlyCost() {
      var me=this;
      if (me.isFairUse || !me.subscriptionParams || !me.subscriptionParams.maxMonthlyCost || me.subscriptionParams.maxMonthlyCost<=0  || me.subscriptionParams.maxMonthlyCost===2147483647) return -1;
      return me.subscriptionParams.maxMonthlyCost;
    },
    maxDailyQueries() {
      var me=this;
      if (me.isFairUse || !me.subscriptionParams || !me.subscriptionParams.maxQueries || me.subscriptionParams.maxQueries<=0 || me.subscriptionParams.maxQueries===2147483647) return -1;
      return me.subscriptionParams.maxQueries;
    },
    maxMonthlyQueries() {
      var me=this;
      if (me.isFairUse || !me.subscriptionParams || !me.subscriptionParams.maxMonthlyQueries || me.subscriptionParams.maxMonthlyQueries<=0|| me.subscriptionParams.maxMonthlyQueries===2147483647) return -1;
      return me.subscriptionParams.maxMonthlyQueries;
    },
    isFairUse() {
      var me=this;
      return me.subscriptionParams && me.subscriptionParams.fairUsageMaxDailyCost>0;
    },
    isFixedLimit() {
      return !this.isFairUse && !this.isMetered;
    },
    isMetered() {
      return !this.isFairUse && this.freeDailyCost>0;
    },
    freeDailyCost:function() {
      return this.subscriptionParams && this.subscriptionParams.freeDailyCost;
    },
    isMeteredNoPaymentSrc:function() {
      return this.subscriptionParams && this.subscriptionParams.isMeteredNoPaymentSrc===1;
    },
    maxDailyQueriesText() {
      if (!this.maxDailyQueries || this.maxDailyQueries==-1) return null
      return VcPrettyNumberFormatter.format(this.maxDailyQueries);
    },
    maxMonthlyQueriesText() {
      if (!this.maxMonthlyQueries || this.maxMonthlyQueries==-1) return null
      return VcPrettyNumberFormatter.format(this.maxMonthlyQueries);
    },
    maxDailyCostText() {
      var me=this;
      if (me.maxDailyCost>0) return VcPrettyNumberFormatter.format(me.maxDailyCost);
     // if (me.maxMonthlyCost>0) return VcPrettyNumberFormatter.format(me.maxMonthlyCost);
      return null;
    },
    maxMonthlyCostText() {
       var me=this;
       if (me.maxMonthlyCost>0) return VcPrettyNumberFormatter.format(me.maxMonthlyCost);
         return null;
    },
    freeDailyCostText() {
      return VcPrettyNumberFormatter.format(this.freeDailyCost);
    },

    costPercentText:function() {
      var me=this;
      var cost=me.currentPeriodUsage.cost;
      var maxCost=me.freeDailyCost;
      if (!maxCost) maxCost=me.maxDailyCost;
      var used=100*cost/maxCost;
      if (used>100) used=100;
      if (used<1) return "<1%";
      return Math.round(used)+"%";
    },
    queriesText() {
      return VcPrettyNumberFormatter.format(this.currentPeriodUsage.queryCount);
    },
    periodQueriesText() {
      return VcPrettyNumberFormatter.format(this.currentPeriodUsage.periodQueryCount);
    },
    costText() {
      return VcPrettyNumberFormatter.format(this.currentPeriodUsage.cost);
    },
    periodCostText() {
      return VcPrettyNumberFormatter.format(this.currentPeriodUsage.periodQueryCost);
    },
    availableCreditsText() {
      return VcPrettyNumberFormatter.format(this.currentPeriodUsage.availableCredits);
    },
    currentPeriodUsage() {
      return this.usageInfo && this.usageInfo.currentPeriodUsage;
    },
    historicalUsage() {
      return this.usageInfo && this.usageInfo.historicalUsage;
    },
    historicalUsageReverse() {
        return this.historicalUsage && this.historicalUsage.reverse();
    },
    noData() {
      return !this.usageInfo;
    },
    hasSession() {
      return this.sessionId;
    },
    upcomingInvoice:function() {
      var me=this;
      if (!me.usageInfo || !me.usageInfo.customerInfo || !me.usageInfo.customerInfo.subscriptions || !me.usageInfo.customerInfo.subscriptions.length) return null;
      return me.usageInfo.customerInfo.subscriptions[0].upcomingInvoice;
    },
    invoiceBalance:function() {
      var me=this;
      if (!me.upcomingInvoice) return 0;
      return  (me.upcomingInvoice.amount/100);
    },
    invoiceBalanceText:function() {
      var me=this;
      if (!me.invoiceBalance) return "-";
      return "$"+(me.invoiceBalance);
    },
    invoiceDueDate:function() {
      var me=this;

      var date=me.upcomingInvoice && new Date(me.upcomingInvoice.invoiceDate)
      if (!date) return "-";
      return VcDateUtils.formatDate(date);

    },
  },
  updated() {
   
  },
  unmounted() {
    var me=this;
  },
  mounted() {
    var me=this;
   
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    me.isContainerInited=vcCommunicator.isInited || me.sessionId;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.isContainerInited=true;
      me.refreshUsageInfo();
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
    });

    
    me.refreshUsageInfo();
  },
  components: {
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .kpi .card {
    height:150px
  }
</style>